import { j as o } from "../../jsx-runtime.BREq8dyb.js";
import { faEllipsisV as d } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as t } from "@fortawesome/react-fontawesome";
import { ButtonGroup as m, Dropdown as c, MenuButton as p, IconButton as x, Menu as u, MenuItem as j, ListItemDecorator as f } from "@mui/joy";
import { memo as h } from "react";
const D = h(({
  menuItems: e,
  buttons: l
}) => /* @__PURE__ */ o.jsxs(m, { className: "DqSidePanelTitleToolbar-root", sx: {
  "--ButtonGroup-connected": 0,
  alignSelf: "flex-start"
}, variant: "plain", children: [
  Array.isArray(e) && e.length > 0 ? /* @__PURE__ */ o.jsxs(c, { children: [
    /* @__PURE__ */ o.jsx(p, { endDecorator: null, slots: {
      root: x
    }, children: /* @__PURE__ */ o.jsx(t, { icon: d }) }),
    /* @__PURE__ */ o.jsx(u, { placement: "bottom-end", sx: {
      "--ListItemDecorator-size": "1.5rem",
      "--joy-zIndex-popup": "calc(var(--joy-zIndex-modal) + 1)"
      // NOTE: By default modals cover popups, but this particular menu should be on top
    }, children: e.map(({
      color: n,
      icon: r,
      label: i,
      onClick: a
    }, s) => /* @__PURE__ */ o.jsxs(j, { color: n, onClick: a, children: [
      r ? /* @__PURE__ */ o.jsx(f, { children: /* @__PURE__ */ o.jsx(t, { fixedWidth: !0, icon: r }) }) : null,
      i
    ] }, s)) })
  ] }) : null,
  l
] }));
D.displayName = "DqSidePanelTitleToolbar";
export {
  D as default
};
//# sourceMappingURL=DqSidePanelTitleToolbar.js.map
